import React from 'react';
import EImg from './EImg';

const EMagic = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Magician"
		aria-label="Emoji: Top hat"
		alt="🎩"
		src="https://abs.twimg.com/emoji/v2/72x72/1f3a9.png"
	/>
);

export default EMagic;
